export const variants = {
  enter: dir => {
    return {
      x: dir > 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: dir => {
    return {
      zIndex: 0,
      x: dir < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
};
export const swipeConfidenceThreshold = 10000;
export const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity;
};